import { render } from "./HeartRateZones.vue?vue&type=template&id=32c277d7&scoped=true"
import script from "./HeartRateZones.vue?vue&type=script&lang=js"
export * from "./HeartRateZones.vue?vue&type=script&lang=js"

import "./HeartRateZones.vue?vue&type=style&index=0&id=32c277d7&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c277d7"]])

export default __exports__